/**
 * Booked-value totals for admin screens, on TRAVEL figures: a Faye travel
 * insurance premium rides inside a booking's totals (migration 156) but is
 * collected for Faye, so it is never part of a portfolio's value or of what a
 * customer has spent on trips. Each function keeps the exact field chain its
 * screen always used, so a booking without a premium totals as before.
 */
import { insurancePremiumCents, withoutInsurancePremium } from '../../supabase/functions/_shared/trip-insurance.js';

/** Dashboard "Portfolio": the booked value of every trip in view. */
export function portfolioTravelValue(flights) {
  return (flights || []).reduce((sum, flight) => {
    const t = withoutInsurancePremium(flight);
    return sum + (t.grand_total_with_hold || t.grand_total || t.total_amount || 0);
  }, 0);
}

/** UserDetails "Total Spent": what the customer spent on their trips. */
export function customerTravelSpent(bookings) {
  return (bookings || []).reduce((sum, b) => {
    const t = withoutInsurancePremium(b);
    return sum + (parseFloat(t.grand_total || t.total_amount || 0));
  }, 0);
}

/** One booking's row on UserDetails: the trip amount, and its premium (0 without one). */
export function bookingTravelAmount(booking) {
  const t = withoutInsurancePremium(booking || {});
  return {
    amount: parseFloat(t.grand_total || t.grand_total_with_hold || t.total_amount || 0),
    insurancePremium: insurancePremiumCents(booking) / 100,
  };
}
